export const supportedLanguageLocales = {
  da: 'da_DK',
  de: 'de_DE',
  en: 'en_GB',
  es: 'es_ES',
  et: 'et_EE',
  fi: 'fi_FI',
  fr: 'fr_FR',
  it: 'it_IT',
  nl: 'nl_NL',
  no: 'no_NB',
  pt: 'pt_PT',
  ru: 'ru_RU',
  sv: 'sv_SE',
};

export const validLanguages = [
  'da',
  'de',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'it',
  'nl',
  'no',
  'pt',
  'ru',
  'sv',
];

const createLocaleAliasMap = () => {
  const aliases = {};

  Object.entries(supportedLanguageLocales).forEach(([language, locale]) => {
    const languageLower = language.toLowerCase();
    const localeLower = locale.toLowerCase();
    const hyphenLocale = localeLower.replace('_', '-');
    const underscoreLocale = hyphenLocale.replace('-', '_');
    const parts = hyphenLocale.split('-');

    const variants = new Set([
      language,
      languageLower,
      locale,
      localeLower,
      hyphenLocale,
      underscoreLocale,
    ]);

    parts.forEach((part) => {
      if (part) {
        variants.add(part);
        variants.add(part.toLowerCase());
      }
    });

    variants.forEach((variant) => {
      if (!variant) {
        return;
      }

      aliases[variant.toLowerCase()] = languageLower;
    });
  });

  return aliases;
};

export const localeAliasMap = createLocaleAliasMap();

export const mapToSupportedLanguage = (locale) => {
  if (!locale || typeof locale !== 'string') {
    return null;
  }

  const lower = locale.toLowerCase();

  if (localeAliasMap[lower]) {
    return localeAliasMap[lower];
  }

  const base = lower.split(/[-_]/)[0];

  if (localeAliasMap[base]) {
    return localeAliasMap[base];
  }

  if (validLanguages.includes(lower)) {
    return lower;
  }

  if (validLanguages.includes(base)) {
    return base;
  }

  return null;
};

export const mapPreferredLocalesToSupportedLanguage = (locales = []) => {
  for (const locale of locales) {
    const mapped = mapToSupportedLanguage(locale);
    if (mapped) {
      return mapped;
    }
  }

  return null;
};
